/* MITIPOT — shop
   Order opens an editable cart drawer (quantity, remove) before checkout.
   Clicking Order twice never double-adds: if the item is already in the
   cart we just open the drawer. If anything fails we fall back to a plain
   form submit rather than leaving someone staring at a dead button. */
(() => {
  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  function init(root) {
    if (!root || root.dataset.mpInit === 'true') return;
    root.dataset.mpInit = 'true';

    const form = root.querySelector('#mp-product-form');
    const buttons = [...root.querySelectorAll('[data-mp-buy]')];
    const drawer = root.querySelector('[data-mp-cart]');
    const linesEl = root.querySelector('[data-mp-cart-lines]');
    const subEl = root.querySelector('[data-mp-cart-sub]');
    const coBtn = drawer ? drawer.querySelector('[data-mp-co]') : null;
    const variantId = form ? (form.querySelector('[name="id"]') || {}).value : null;

    async function getCart() {
      const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!r.ok) throw new Error('cart');
      return r.json();
    }

    function render(cart) {
      if (!cart.items.length) {
        linesEl.innerHTML = '<p class="mp-cart-empty">Your cart is empty.</p>';
      } else {
        linesEl.innerHTML = cart.items.map(it => (
          '<div class="mp-cart-line" data-key="' + it.key + '">' +
            '<div class="mp-cart-line-top"><span>' + it.product_title + '</span>' +
            '<b>' + money(it.final_line_price) + '</b></div>' +
            '<div class="mp-cart-line-ctl">' +
              '<div class="mp-qty">' +
                '<button type="button" data-mp-dec aria-label="Decrease quantity">&minus;</button>' +
                '<span>' + it.quantity + '</span>' +
                '<button type="button" data-mp-inc aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<button type="button" class="mp-cart-rm" data-mp-rm>Remove</button>' +
            '</div>' +
          '</div>'
        )).join('');
      }
      subEl.textContent = money(cart.items_subtotal_price);
      if (coBtn) coBtn.disabled = !cart.items.length;
    }

    async function change(key, qty) {
      const r = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      if (r.ok) render(await r.json());
    }

    function openCart() { drawer.hidden = false; document.body.style.overflow = 'hidden'; }
    function closeCart() { drawer.hidden = true; document.body.style.overflow = ''; }

    if (drawer) {
      drawer.addEventListener('click', e => {
        if (e.target.closest('[data-mp-cart-close]')) { closeCart(); return; }
        const line = e.target.closest('.mp-cart-line');
        if (!line) return;
        const key = line.dataset.key;
        const qty = Number(line.querySelector('.mp-qty span').textContent) || 0;
        if (e.target.closest('[data-mp-inc]')) change(key, qty + 1);
        else if (e.target.closest('[data-mp-dec]')) change(key, Math.max(0, qty - 1));
        else if (e.target.closest('[data-mp-rm]')) change(key, 0);
      });
      if (coBtn) coBtn.addEventListener('click', () => { window.location.href = '/checkout'; });
      document.addEventListener('keydown', e => {
        if (e.key === 'Escape' && !drawer.hidden) closeCart();
      });
    }

    buttons.forEach(btn => btn.addEventListener('click', async e => {
      e.preventDefault();
      if (btn.disabled) return;
      btn.dataset.label = btn.textContent;
      btn.textContent = 'Adding…';
      btn.disabled = true;
      try {
        if (!drawer || !variantId) throw new Error('nocart');
        let cart = await getCart();
        const inCart = cart.items.some(it => String(it.variant_id) === String(variantId));
        if (!inCart) {
          const r = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
          });
          if (!r.ok) throw new Error('add');
          cart = await getCart();
        }
        render(cart);
        openCart();
      } catch (err) {
        if (form) HTMLFormElement.prototype.submit.call(form);
      } finally {
        btn.disabled = false;
        btn.textContent = btn.dataset.label || 'Order';
      }
    }));
  }

  /* dish loops: load + play only on screen */
  function lazyVideos(root) {
    var vids = [].slice.call(root.querySelectorAll('video[data-lazy]'));
    if (!vids.length) return;
    if ('IntersectionObserver' in window &&
        !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) {
            if (!v.getAttribute('src')) v.src = v.getAttribute('data-lazy');
            v.play().catch(function () {});
          } else { v.pause(); }
        });
      }, { threshold: 0.25 });
      vids.forEach(function (v) { io.observe(v); });
    }
  }

  document.querySelectorAll('.mp').forEach(function (r) { init(r); lazyVideos(r); });
  document.addEventListener('shopify:section:load', e => {
    e.target.querySelectorAll('.mp').forEach(init);
  });
})();
